<script setup>
import {ref, onBeforeMount, reactive, nextTick} from 'vue';
import YTCreateAdv from "./components/create/index.vue"
import {getRoute} from "@/hooks/getRoute.js";
import {addAdvertisement, detailAdvertisement, editAdvertisement} from "@/api/advertisement/advertisement.js";
import {ElMessage} from "element-plus";
import router from "@/router/index.js";
import {listAdvertisementReviewLog} from "@/api/advertisementReviewLog/advertisementReviewLog.js";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)

onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.advertisementId)
  if (isEdit.value) {
    await getDetail(route.query.advertisementId)
    await handleGetAdvLog(route.query.advertisementId)
  }
})

// 广告日志列表
const listAdvLog = ref([])
// 处理获取广告审批日志
const handleGetAdvLog = async (id) => {
  try {
    loading.value = true
    listAdvLog.value = await listAdvertisementReviewLog(id)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 加载状态
const loading = ref(false)
// 创建广告
const createAdv = async (param) => {
  try {
    loading.value = true
    if (isEdit.value) {
      await editAdvertisement(param)
    } else {
      await addAdvertisement(param)
    }
    ElMessage.success(isEdit.value ? '编辑成功' : '创建成功')
    router.push({ path: '/listAdvertisements' })
    console.log("param", param)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 表单信息
const ruleForm = reactive({
  advertisementId: null,
  advertisementName: null,
  advertisementNameEn: null,
  advertisementType: "BANNER",
  positionId: null,
  sort: null,
  onlineTime: null,
  offlineTime: null,
  effectiveValue: null,
  effectiveType: null,
  coverImage: null,
  advDesc: null,
  linkType: null,
  linkValue: null,
  advLog: []
})
// 创建广告组件锚点
const YTCreateAdvRef = ref()
// 获取广告详情
const getDetail = async (id) => {
  try {
    loading.value = true
    let param = {
      id: id
    }
    const res = await detailAdvertisement(id)
    Object.assign(ruleForm, res)
    console.log("ruleForm", ruleForm)
    console.log("YTCreateAdvRef.value", YTCreateAdvRef.value)
    YTCreateAdvRef.value.handleReview(ruleForm)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <YTCreateAdv ref="YTCreateAdvRef" :readOnly="false" :listAdvLog="listAdvLog" :isEdit="isEdit" @submit="createAdv" :loading="loading" @update:loading="val => loading = val"></YTCreateAdv>
    </v-container>
  </div>
</template>

<style scoped>

</style>
